import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import { Alert, AlertTitle } from '@material-ui/lab';

import PropTypes from 'prop-types';

PremiumFeatureAlert.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

function PremiumFeatureAlert(props) {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Collapse in={open}>
      <Alert
        severity="error"
        action={(
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        )}
      >
        <AlertTitle id="simple-dialog-title">
          This
          <b> Premium Feature </b>
          {' '}
          is not yet available for this account.
        </AlertTitle>
        You have been redirected to the default page. You can test the feature using the following request form.
      </Alert>
    </Collapse>
  );
}

export default PremiumFeatureAlert;
